import React from 'react';
import Logo from './Logo';
import { Twitter, MessageCircle } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="border-t border-gray-800 mt-12">
      <div className="container mx-auto px-4 sm:px-6 py-8">
        {/* Main Content */}
        <div className="flex flex-col space-y-8 px-8 md:px-0">
          {/* Logo Row */}
          <div className='flex justify-start items-center text-center mb-[-30px]'>
            <Logo className="ml-[-12px] md:ml-[-32px] w-20 h-20 md:w-32 md:h-32 " />
            <h2 className="text-2xl font-medium text-white ml-[-12px]">AgentPulse</h2>
          </div>

          {/* Info Row */}
          <div className="flex justify-between items-start">
            {/* Description */}
            <div className="max-w-lg">
              <p className="text-gray-400 text-sm pr-8">
                Your gateway to discovering and analyzing AI agents. Track, compare, and stay updated
                with the latest developments in autonomous AI systems.
              </p>
            </div>


            <div className="flex ">
              {/* Platform Links */}
              <div className="text-right mr-4 pr-4">
                <h3 className="text-white font-medium mb-4">Our Socials</h3>
                <ul className="space-y-2">
                  <li>
                    <a href="https://x.com/agent_pulse" className="text-gray-400 hover:text-white text-sm transition-colors">
                      Twitter (X)
                    </a>
                  </li>
                  <li>
                    <a href="https://something.com" className="text-gray-400 hover:text-white text-sm transition-colors">
                      Telegram
                    </a>
                  </li>
                </ul>
              </div>
              <div className="text-right">
                <h3 className="text-white font-medium mb-4">Platform</h3>
                <ul className="space-y-2">
                  <li>
                    <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">
                      Search Agents
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">
                      Add Agent
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Agent-Pulse. All rights reserved.
          </div>
          <div className="text-gray-400 text-sm">
            Made with ❤️ by{' '}
            <a
              href="https://wipiway.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-purple-400 hover:text-purple-300 transition-colors"
            >
              Wipiway
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;